import { combineReducers } from 'redux'
import { actions } from '../constants'

import { factoryReducer as createFactoryReducer, flattenStringMap } from '../../../../../reducers/utils'

import ui from './ui'
import data from './data'

const combinedReducer = combineReducers({
  ui,
  data,
})

export default createFactoryReducer(
  //@ts-ignore
  {
    registerType: actions.INITIALIZE,
  },
  flattenStringMap(actions),
  combinedReducer,
  (meta) => meta.ID,
)
